/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ICON_BIG_womanback': {
    width: 46,
    height: 56,
    viewBox: '0 0 46 56',
    data: '<path pid="0" d="M31.4 20.263c1.133-2.905 6.233-9.103 8.5-11.62l-8.5-2.324M21.2 1.67c3.4-1.162 3.966-.581 7.933 0 3.967.58 5.1.58 9.634 1.162 6.8 1.394 6.989 4.454 6.233 5.81C42.733 13.29 35.803 23.927 33.667 27c-.864 4.427-2.267 5.464-2.267 15.341 0 4.68 2.735 6.556 3.087 13.159H13.48c.198-6.443 2.618-7.863 2.618-10.835m13.6-18.592c-1.7-6.972.567-11.62.567-15.106 0-3.486-.566-8.134-6.233-8.134S17.8 7.48 17.8 10.967c0 3.486 2.266 8.134.566 15.106M16.1 44.665c-1.7-2.324-6.233-2.905-10.767-5.23C.8 37.113.595 36.5 1.932 34.208 3.802 31 13.033 21.5 17 21.5m-.9 23.165c.566 2.324 1.7 1.768.566 5.835m6.8-44.181c5.1 4.067 1.134 11.62 2.267 21.497M22.9 9.805c-1.7 7.553 1.133 8.695-1.097 19.695m-5.137 10.517c-2.081-.96-8.806-4.467-10.2-5.23.944-.967 5.003-3.463 7.837-5.787 0 4.648 1.668 7.648 2.363 11.017zm0 0l2.267.58c2.267.582 2.267 2.906 6.233 5.23m-6.233.581c1.446 1.553 1.9 2.58 4.533 3.486m-2.833-4.648c1.133 1.162 3.4 2.905 5.667 3.486M24 30v11"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/ICON_BIG_womanback.js